import React from 'react';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {StatusField} from '@views/checklists/fields/status_settings/StatusField';

export function DisplayWhenField(props: IListColumnProps) {
    return <StatusField {...props} actualName="display_when"/>;
}
